import React from "react";
import Typography from "@material-ui/core/Typography";
import tableicons from "../tableicons";
import MaterialTable from "material-table";
import CheckIcon from "@material-ui/icons/Check";
import {tagResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import SearchIcon from "@material-ui/icons/Search";

class Conflictos extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            cargando:true,
            selectedRow: null,
            datos: [],
            openSnackbar: false,
            severity:'',
            message:'',
            checked: {},
            dialog_detalle:false,
            rowData: null
        }
    }
    verDetalles = (rowData) =>{
        this.props.history.push("/detalles_conflictos/" + rowData.tag)
    }

    getTagsConflictos = () =>{
        tagResources.getTagsConflictos().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,datos:result.detalle_conflicto})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true,cargando:false, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.setState({cargando:false})
            console.log(error)
        });
    }

    componentDidMount() {
        this.getTagsConflictos()
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>Duplicados</Typography>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=""
                    data={this.state.datos}
                    columns={[
                        { title: 'Tag', field: 'tag',
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }},
                        { title: 'Ubicación', field: 'ubicacion_path',
                            cellStyle: {
                                width: 700,
                                maxWidth: 700,
                            },
                            headerStyle: {
                                width: 700,
                                maxWidth: 700
                            }},
                        { title: 'N° descargas', field: 'descargas' },
                        { title: 'Cantidad capt.', field: 'cantidad'},
                        { title: 'Revisado', field: 'resuelto',
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            },
                            render: rowData => (rowData.resuelto ? <CheckIcon/> : null),}
                    ]}
                    actions={[
                        {
                            icon:  () => <SearchIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Ver detalle conflicto',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                        },
                    ]}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default Conflictos;